const clickCartProductDetail = (lineItem_id) => {
  const targetList = document.querySelectorAll(
    '[data-lineitem_id="' + lineItem_id + '"]'
  );
  for (let j = 0; j < targetList.length; j++) {
    const targetClassList = targetList[j].classList;
    if (targetClassList.contains('product-detail_popup')) {
      const popup = targetList[j];
      popup.classList.add('is-show');
    }
  }
  document.body.style.overflow = 'hidden';
}

const closeCartProductDetail = (lineItem_id) => {
  const targetList = document.querySelectorAll(
    '[data-lineitem_id="' + lineItem_id + '"]'
  );
  for (let j = 0; j < targetList.length; j++) {
    const targetClassList = targetList[j].classList;
    if (targetClassList.contains('product-detail_popup')) {
      const popup = targetList[j];
      popup.classList.remove('is-show');
    }
  }
  document.body.style.overflow = 'auto';
}

const spOpenTimeline = document.getElementsByClassName('timeline_open');
const collectionMtmSidebar = document.getElementsByClassName('collection-mtm-sidebar');
for(var i=0; i<spOpenTimeline.length; i++) {
    spOpenTimeline[i].addEventListener('click', function() {
        for(var i=0; i<collectionMtmSidebar.length; i++) {
            collectionMtmSidebar[i].classList.add('active');
        }
    });
}
const spCloseTimeline = document.getElementsByClassName('timeline_close');
for(var i=0; i<spCloseTimeline.length; i++) {
    spCloseTimeline[i].addEventListener('click', function() {
        collectionMtmSidebar[0].classList.remove('active');
    })
}

document.addEventListener("DOMContentLoaded", function() {
  var element = document.getElementById("custom__md-footer-selector-block");
  if (!element) return;

  function moveElement() {
      var pcTarget = document.querySelector(".pc-insert-location");
      var spTarget = document.querySelector(".sp-insert-location");
      var isMobile = window.matchMedia("(max-width: 767px)").matches;
      if (isMobile && spTarget) {
          spTarget.appendChild(element);
      } else if (!isMobile && pcTarget) {
          pcTarget.appendChild(element);
      }
      element.style.display = "block";
  }

  moveElement();
  window.addEventListener("resize", moveElement);
});